import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../../api/ApiCall";

export const listQuestions = createAsyncThunk(
  "listQuestions",
    async ({ search = "", page = 1, limit = 10 }) => {
      const request = await api(
        `api/admin/questions?search=${search}&page=${page}&limit=${limit}`,
        "",
        "get"
      );
      return request;
    }
);

export const getQuestionById = createAsyncThunk(
    "getQuestionById",
    async (data) => {
      const request = await api(`api/admin/questions/${data}`, "", "get");
      return request;
    }
  );

export const addQuestion = createAsyncThunk(
  "addQuestion",
    async (data) => {
    const request = await api("api/admin/questions/add", data, "post");
    return request;
    }
);

export const updateQuestion = createAsyncThunk(
  "updateQuestion",
    async ({ data, id }) => {
      const request = await api(`api/admin/questions/update/${id}`, data, "post");
      return request;
    }   
);

export const getQuestionsForUI = createAsyncThunk(
  "getQuestionsForUI",
  async () => {
    const request = await api(`api/admin/questionsforui`, "", "get");
    return request;
  }
);

export const deleteQuestion = createAsyncThunk("deleteQuestion", async (id) => {
  const request = await api(`api/admin/questions/delete/${id}`, {}, "delete");
  return request;
});


const questionSlice = createSlice({
  name: "questions",
  initialState: {
    questions: [],
    question: null,
    totalCount: 0,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(listQuestions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(listQuestions.fulfilled, (state, action) => {
        state.loading = false;
        state.questions = action.payload.questions;
        state.totalCount = action.payload.totalCount;
      })
      .addCase(listQuestions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(addQuestion.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addQuestion.fulfilled, (state, action) => {
        state.loading = false;
        state.questions.push(action.payload);
      })
      .addCase(addQuestion.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getQuestionById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getQuestionById.fulfilled, (state, action) => {
        state.loading = false;
        state.question = action.payload;
      })
      .addCase(getQuestionById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateQuestion.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateQuestion.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.questions.findIndex(
          (q) => q.id === action.payload.id
        );
        if (index !== -1) {
          state.questions[index] = action.payload;
        }
      })
      .addCase(updateQuestion.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteQuestion.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteQuestion.fulfilled, (state, action) => {
        state.loading = false;
        state.questions = state.questions.filter(
          (q) => q.id !== action.payload.id
        );
      })
      .addCase(deleteQuestion.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default questionSlice.reducer;